import { observer } from 'mobx-react';
import { memo } from 'react';
import { ItemsInventoryHeader } from '../../containers/ItemsInventoryHeader/ItemsInventoryHeader';
import { ProductsList } from './containers/ProductsList/ProductsList';
import { itemsInventoryProductStore } from './store/ItemsInventoryProductStore';
import { Table } from 'src/view/components/Table/Table';

const ProductsScreen: React.FC = memo(
  observer((): JSX.Element => {
    return (
      <Table>
        <>
          <ItemsInventoryHeader
            loading={itemsInventoryProductStore.isLoading}
            filters={itemsInventoryProductStore.filters}
            totalItems={itemsInventoryProductStore.pagination.total}
            setFilters={itemsInventoryProductStore.setFilters}
          />
          <ProductsList />
        </>
      </Table>
    );
  })
);

export default ProductsScreen;
